import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DownloadIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8.53 4.02a6 6 0 0 1 6.22 4.27 1 1 0 0 0 .96.71h1.79a3.5 3.5 0 0 1 1.94 6.41 1 1 0 0 0 1.12 1.66A5.5 5.5 0 0 0 17.5 7h-1.08a8 8 0 1 0-13.13 8.6 1 1 0 1 0 1.42-1.4A6 6 0 0 1 8.53 4.02Z" />
      <path d="M8.7 16.3a1 1 0 0 0-1.4 1.4l3.99 4a1 1 0 0 0 1.1.22 1 1 0 0 0 .32-.22l4-4a1 1 0 0 0-1.42-1.4L13 18.58V12a1 1 0 1 0-2 0v6.59l-2.3-2.3Z" />
    </Icon>
  )
);
export default DownloadIcon;
